import "./style.scss";
import { useState } from "react";
import {
  FiEdit,
  FiEye,
  FiMoreHorizontal,
  FiPlus,
  FiTrash2,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import StudentInstructorService from "../../../services/student-instructor.service";
import { useDispatch } from "react-redux";
import { getInstructorsFromApi, getStudentsFromApi, setStatusForStudentInstructor } from "../../../store/slices/instructor-student.slice";
import { API_STATUS } from "../../../constants";
import { confirmAlert } from 'react-confirm-alert'
import useCustomToast from "../../../hooks/useCustomToast";


type ICardPropsType = {
  cardImage: string,
  classes?: string,
  student?: boolean,
  data?: any,
  key?: number
}

function InstructorCard({ cardImage = "", classes = "", student = false, data }: ICardPropsType) {
  const [showMenu, setShowMenu] = useState(false);
  const dispatch = useDispatch()

  const customToast = useCustomToast()

  // Remove student instructor
  const handleRemoveStudentInstructor = async (id: string): Promise<void> => {
    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to remove?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
              const res: any = await StudentInstructorService.remove(id)
              if (res?.response?.status >= 400) {
                customToast(res?.response?.data?.message || 'Something went wrong', "error")
                return
              }
              customToast("Removed Successfully", "success")
              dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
              setTimeout(() => {
                dispatch(student ? getStudentsFromApi() : getInstructorsFromApi())
              }, 1200)
            } catch (e) {
              dispatch(setStatusForStudentInstructor(API_STATUS.FAILED))
            }
            finally {
              dispatch(setStatusForStudentInstructor(API_STATUS.IDEAL))
            }
          },
        },
        {
          label: 'No',
          onClick: () => { },
        },
      ],
    })
  }

  return (
    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
      <div className={`instructor_card ` + classes}>
        <div
          className={`menu ${showMenu ? "active" : ""}`}
          onClick={() => setShowMenu(!showMenu)}
        >
          <span className="icon">
            <FiMoreHorizontal />
          </span>
          <ul className="options">
            <li>
              <span>
                <FiEye />
              </span>
              <span>View</span>
            </li>
            <li>
              <span>
                <FiEdit />
              </span>
              <span>Edit</span>
            </li>
            {student && (
              <li>
                <Link to="/training/endorsement/create">
                  <span>
                    <FiPlus />
                  </span>
                  <span>Add Endorsements</span>
                </Link>
              </li>
            )}
            <li className="trash" onClick={() => handleRemoveStudentInstructor(data?.userId?._id)}>
              <span>
                <FiTrash2 />
              </span>
              <span>Delete</span>
            </li>
          </ul>
        </div>
        <div className="profile_image">
          <img src={cardImage} alt="instructor profile" />
        </div>
        <div className="name">{data?.userId?.firstname} {data?.userId?.lastname}</div>
        <div className="designation text-capitalize">{data?.userId?.role}</div>
      </div>
    </div>
  );
}

export default InstructorCard;
